import { connect } from 'react-redux'

import { getUrl } from '@buffer-mono/shared-utils/bibe'

import type { RootState } from '~publish/legacy/store'

import ProfilesDisconnectedBanner from './components/ProfilesDisconnectedBanner'

export default connect(
  (state: RootState) => {
    let displayExtraMessage = false
    const selectedProfile = state.profileSidebar?.selectedProfile

    if (
      selectedProfile?.service === 'instagram' &&
      selectedProfile?.service_type === 'profile'
    ) {
      displayExtraMessage = true
    }

    return {
      profileId: selectedProfile?.id,
      service: selectedProfile?.service,
      displayExtraMessage,
      canReconnectChannels: state.organizations.selected?.canReconnectChannels,
      ownerEmail: state.organizations.selected?.ownerEmail,
    }
  },
  () => ({
    onReconnectProfileClick: (): void => {
      window.location.assign(
        getUrl('https://publish.buffer.com/settings/channels'),
      )
    },
  }),
)(ProfilesDisconnectedBanner)
